import { Dialog, DialogActions, DialogContent, DialogTitle, Fab, makeStyles, TextField, Typography } from '@material-ui/core';
import ExitIcon from '@material-ui/icons/Clear';
import SearchIcon from '@material-ui/icons/Search';
import React, { useState } from 'react';
import { useGlobal } from 'reactn';
import { IGlobalState } from '../states/GlobalState';
import { globalStyles } from '../style/GlobalStyles';
import { deleteElaborazione, getElaborazioni } from '../services/api';
import { ElabDto } from '../dto/Dtos';
import auth from '../types/auth';
import { Elaborazione } from './Elaborazione';
import { Applicazioni } from '../types/types';

const useStyles = makeStyles({
    // root: {
    //     flexGrow: 1,
    // },
    dialog: {
        maxHeight: "50vh"
    }
});

export type CaricaModalProps = {
    isOpen: boolean;
    handleClose: any;
    handleLoad: any;
    handleDelete: any;
    // applicazione: number;
}

export default function CaricaElaborazione(props: CaricaModalProps) {
    const classes = useStyles();
    const gClasses = globalStyles();
    const [global] = useGlobal<IGlobalState>();
    const [elaborazioni, setElaborazioni] = useState<ElabDto[]>([]);
    const [searchText, setSearchText] = useState<string>("");
    const [application,] = useGlobal<IGlobalState, 'application'>('application');
    const [identity] = useGlobal<IGlobalState, 'identity'>('identity');
    let prov = auth.getProvincia(global);

    let username = identity?.Username!;
    function handleCarica(id: number) {
        props.handleLoad(id);
    }

    function handleDelete(id: number) {
        deleteElaborazione(username, id, global).then(x=> props.handleDelete(id));
    }

    function handleCerca(e: any) {
        setSearchText(e.target.value);
    }

    React.useEffect(() => {
        console.log('Global.application: ' + application);
        if (application && application > 0 && application <= Applicazioni.Budget4u && props.isOpen === true)
            getElaborazioni(prov!, username, application, global).then((x: any) => setElaborazioni(x));
    }, 
    // eslint-disable-next-line
    [props.isOpen]);

    return (
        <div className={gClasses.root}>
            <Dialog
                open={props.isOpen}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{<Typography variant="h5" color="primary">Carica elaborazione</Typography>}</DialogTitle>
                <DialogContent dividers>
                    <React.Fragment>
                        <React.Fragment>
                            <SearchIcon style={{ width: '2rem', height: '2rem' }} color="primary" />
                            <TextField placeholder="Ricerca" value={searchText} onChange={handleCerca}></TextField>
                        </React.Fragment>
                        <div className={classes.dialog}>
                            {elaborazioni !== null && elaborazioni !== undefined && elaborazioni.length > 0 ?
                                elaborazioni.map((el: ElabDto, index: number) => (
                                    <React.Fragment key={index}>
                                        <Elaborazione searchString={searchText} key={index} item={el} onCarica={handleCarica} onCancella={handleDelete} />
                                    </React.Fragment>
                                ))
                                : <Typography variant="body1" color="error">Nessuna elaborazione trovata</Typography>}
                        </div>
                    </React.Fragment>
                </DialogContent>
                <DialogActions>
                    <Fab onClick={props.handleClose}>
                        <ExitIcon style={{ width: '2rem', height: '2rem' }} color="secondary" titleAccess="Chiudi" />
                    </Fab>
                </DialogActions>
            </Dialog>
        </div>
    );

}